import InputMask from 'inputmask';

const inputTypeTime = (node) => {
  const maskOptions = [
    'hh:mm',
    {
      placeholder: '--:--',
      insertMode: false,
      showMaskOnHover: true,
    },
  ];

  return InputMask(...maskOptions).mask(node);
};

export default inputTypeTime;
